;(function ( $, window, document, undefined ) {

    var pluginName = "switchButton",
        defaults = {
            dataAttributeName           : "active",
            dataAttributeDefaultValue   : 0,
            dataAttributeActiveValue    : 1,
            on                          : null,
            off                         : null,
            ready                       : null
        };

    function SwitchButton( element, options ) {
        this.element = element;

        this.options = $.extend( {}, defaults, options) ;

        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    SwitchButton.prototype = {

        init: function() {
            this.initDataAttribute(this.element, this.options);
            this.ready(this.element, this.options);
            this.clickListener(this.element, this.options);
        },

        clickListener: function (el, options) {
            $(el).on('click', function() {
                if(SwitchButton.prototype.isOff(el, options)) {
                    SwitchButton.prototype.on(el, options);
                }
                if(SwitchButton.prototype.isOn(el, options)) {
                    SwitchButton.prototype.off(el, options);
                }

                SwitchButton.prototype.switchState(el, options);
            });
        },

        ready: function(el, options) {
            if(this.isOff(el, options)) {
                options.off(el, options);
            }

            if(this.isOn(el, options)) {
                options.on(el, options);
            }
        },

        gotDataAttribute: function(el, options) {
            return $(el).data(options.dataAttributeName) !== undefined;
        },

        initDataAttribute: function (el, options) {
            if(this.gotDataAttribute(el, options) === false) {
                $(el).data(options.dataAttributeName, options.dataAttributeDefaultValue);
            }
        },

        isOn: function (el, options) {
            return !this.isOff(el, options);
        },

        on: function (el, options) {
            if(options.on && typeof(options.on) === "function") {
                options.on(el, options);
            }
        },

        isOff: function(el, options) {
            return $(el).data(options.dataAttributeName) === options.dataAttributeDefaultValue;
        },

        off: function(el, options) {
            if(options.off && typeof(options.off) === "function") {
                options.off(el, options);
            }
        },

        switchState: function (el, options) {
            if(this.isOff(el, options)) {
                $(el).data(options.dataAttributeName, options.dataAttributeActiveValue);
            }
            else {
                $(el).data(options.dataAttributeName, options.dataAttributeDefaultValue);
            }
        }
    };

    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName,
                    new SwitchButton( this, options ));
            }
        });
    };

})( jQuery, window, document );


// WEBPACK FOOTER //
// ./app/Resources/assets/default/js/common/SwitchButton.plugin.js